<!-- PDF查看组件 -->
<template>
    <el-row id="pdfIframe" style="height: 100%;background-color: #ffffff;">
        <iframe id="iframe" :src='newPdfUrl' width='100%' height='100%' frameborder='1'></iframe>
        <!-- <iframe id="iframe" :src='pdfUrl+"#toolbar=0"' width='100%' height='100%' frameborder='1'></iframe> -->
        <!-- <a class="qpclass" v-if="!PdfFullScreenShow" @click="fullScreen()">全屏</a>
      <a class="qpclass" v-else @click="quitFullScreen()">退出</a> -->
    </el-row>
</template>

<script>
    import jQuery from 'jquery';
    export default {
        name: "LookPdf",
        props: {
            pdfUrl: {
                type: String,
                default: function() {
                    return '';
                }
            },
        },
        data() {
            return {
                PdfFullScreenShow: false,
                newPdfUrl: ""
            };
        },
        created() {

        },
        mounted() {
            // this.newPdfUrl = '/static/web/viewer.html?file=' + encodeURIComponent(this.pdfUrl);
            this.newPdfUrl = '../../static/pdf/web/viewer.html?file=' + encodeURIComponent(this.pdfUrl);
            // this.newPdfUrl = '../static/web/viewer.html?file=';
        },
        methods: {
            fullScreen() { //全屏
                this.PdfFullScreenShow = true;
                jQuery("#pdfIframe").css("position", 'fixed').css("width", '100%').css("height", '100%').css("z-index",
                    999).css('top', '0').css("left", "0");
            },
            quitFullScreen() { //退出全屏
                this.PdfFullScreenShow = false;
                jQuery("#pdfIframe").css("position", '').css("width", '').css("height", '100%').css("z-index", '').css(
                    'top', '').css("left", "");
            }
        }
    };
</script>

<style lang="less">
    .showBox {
        width: calc(100% - 20px);
        height: calc(100vh - 220px);
        border: 1px solid #D3D3D3;

        img {
            max-width: 100%;
        }
    }

    .qpclass {
        position: absolute;
        right: 59px;
        width: 40px;
        height: 40px;
        bottom: 1px;
        padding: 2px;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        border-radius: 50%;
        background-color: #f2f2f2;
        color: #616161;
    }
</style>



// WEBPACK FOOTER //
// src/components/lookPdf.vue